// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#PortalMap{position:absolute;top:0;bottom:0;left:0;right:0;height:100%;overflow:hidden}`, "",{"version":3,"sources":["webpack://./src/scss/PortalMap.scss"],"names":[],"mappings":"AACA,WACE,iBAAA,CAEA,KAAA,CACA,QAAA,CACA,MAAA,CACA,OAAA,CACA,WAAA,CACA,eAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
